module.exports = __webpack_public_path__ + "media/customizations/sterlingranch/logo-622c3f54c4ee249c20459e0a8d9dc194.png";